import { useCallback, useMemo } from 'react';
import { hasDisplayCategory } from '../../filters/schedule/hasDisplayCategory';
import { useEventSchedule } from './useEventSchedule';

/**
 * Returns all program sessions that don't have a display category set (i.e., the sessions that are displayed directly on the program screen) for a given event ID. The sessions are filtered based on whether they have a display category, and are sorted according to the orderBy parameter.
 *
 * @param {number} eventId - The ID of the event for which to fetch the sessions.
 * @param {Object} options - Options for this hook.
 * @param {function} options.filter - A filter to be applied to all sessions.
 * @param {string} options.orderBy - A sort configuration.
 *
 * @returns {array} An array of uncategorized sessions.
 */
export function useUncategorizedEventSchedule(eventId, { filter, orderBy } = {}) {
    const uncategorizedFilter = useCallback((session) => !hasDisplayCategory(session) && (!filter || filter(session)), [filter]),
        sessions = useEventSchedule(eventId, {
            filter: uncategorizedFilter,
            orderBy,
        });

    return useMemo(() => sessions.filter(uncategorizedFilter), [sessions, uncategorizedFilter]);
}
